import React from 'react';
import Footer from '../Shared/Footer/Footer';
import NavBar2 from '../Shared/NavBar2/NavBar2';
import './Pages.css';
const data = [
    {
        img: "https://i.ibb.co/RNsg97Q/specialities1.png",
        name: "Specialities",
        desc: "Lorem Ipsum proin gravida nibh vel velit auctor temro dat sollici tudin, qui lorat did auctor."
    },
    {
        img: "https://i.ibb.co/SxxPmYx/2.png",
        name: "Our Story",
        desc: "Lorem Ipsum proin gravida nibh vel velit auctor temro dat sollici tudin, qui lorat did auctor."
    },
    {
        img: "https://i.ibb.co/5FqytmB/3.png",
        name: "Celebrations",
        desc: "Lorem Ipsum proin gravida nibh vel velit auctor temro dat sollici tudin, qui lorat did auctor."
    },
    {
        img: "https://i.ibb.co/SnFnWrk/4.png",
        name: "Ask Us",
        desc: "Lorem Ipsum proin gravida nibh vel velit auctor temro dat sollici tudin, qui lorat did auctor."
    },
    {
        img: "https://i.ibb.co/nrqkyrX/5.png",
        name: "Weddings",
        desc: "Lorem Ipsum proin gravida nibh vel velit auctor temro dat sollici tudin, qui lorat did auctor."
    },
    {
        img: "https://i.ibb.co/vLnkg9k/6.png",
        name: "References",
        desc: "Lorem Ipsum proin gravida nibh vel velit auctor temro dat sollici tudin, qui lorat did auctor."
    },
]
// const service = [
//     {
//         img: "https://i.ibb.co/rsbx8pV/a.png",
//         name: "Sweet pink",
//         desc: "Lorem Ipsum proin gravida nibh vel velit auctor aliquetenean sollicitudin, lorem qui bibendum auctor, nisi elit consequat gravida nibh vel velit.",
//         bg_color: "#EAE6E1"
//     },
//     {
//         img: "https://i.ibb.co/7YDnY1F/2.png",
//         name: "Choco Bombs",
//         desc: "Lorem Ipsum proin gravida nibh vel velit auctor aliquetenean sollicitudin, lorem qui bibendum auctor, nisi elit consequat gravida nibh vel velit.",
//         bg_color: "#F4F1EE"
//     },
//     {
//         img: "https://i.ibb.co/MNwDTJL/3.png",
//         name: "Cookie Star",
//         desc: "Lorem Ipsum proin gravida nibh vel velit auctor aliquetenean sollicitudin, lorem qui bibendum auctor, nisi elit consequat gravida nibh vel velit.",
//         bg_color: "#DBCAAD"
//     },
// ]
const WhatWeDo = () => {
    return (
        <>
            <NavBar2 />
            <div className="wwd margin">
                <div className="about1">
                    <h1 className="text-dark mt-5">what we do?</h1>
                    <p>Etiam convallis, felis quis dapibus dictum, libero mauris <br /> luctus nunc, non fringilla purus ligula non justo. Non fringilla purus.</p>
                </div>
            </div>
            {/* wwd component */}
            <div className="container mb-5 ">
                <div className="row mx-auto">
                    {data.map((datadetails) => (
                        <div className="col-lg-4 text-center mb-5" >
                            <div style={{ width: "250px" }} className="container">
                                <img src={datadetails.img} alt="" />
                                <h5>{datadetails.name}</h5>
                                <small>{datadetails.desc}</small>
                            </div>
                        </div>
                    ))}

                </div>
            </div>
            {/* 3 column card */}
            <div className='container-fluid mb-5'>
                <div className="row">
                    <div className="col-lg-4 text-center" style={{ backgroundColor: "#EAE6E1", height: "350px" }}>
                        <img src="https://i.ibb.co/rsbx8pV/a.png" alt="" />
                        <h4>Sweet pink</h4>
                        <p>Lorem Ipsum proin gravida nibh vel velit <br /> auctor aliquetenean sollicitudin, lorem qui <br /> bibendum auctor, nisi elit consequat <br /> gravida nibh vel velit.</p>
                    </div>
                    <div className="col-lg-4 text-center" style={{ backgroundColor: "#F4F1EE" }}>
                        <img src="https://i.ibb.co/7YDnY1F/2.png" alt="" />
                        <h4>Choco Bombs</h4>
                        <p>Lorem Ipsum proin gravida nibh vel velit <br /> auctor aliquetenean sollicitudin, lorem qui <br /> bibendum auctor, nisi elit consequat <br /> gravida nibh vel velit.</p>
                    </div>
                    <div className="col-lg-4 text-center" style={{ backgroundColor: "#DBCAAD" }}>
                        <img src="https://i.ibb.co/MNwDTJL/3.png" alt="" />
                        <h4>Cookie Star</h4>
                        <p>Lorem Ipsum proin gravida nibh vel velit <br /> auctor aliquetenean sollicitudin, lorem qui <br /> bibendum auctor, nisi elit consequat <br /> gravida nibh vel velit.</p>
                    </div>

                </div>
            </div>
            {/* something about us */}
            <div className="wwd_bg">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-sm-12" style={{ width: "550px",paddingTop:"100px" }}>
                            <h4>Something About Us</h4>
                            <p>Lorem Ipsum proin gravida nibh vel velit auctor aliquetenean sollicitudin, lorem qui bibendum auctor, nisi elit consequat gravida nibh vel velit auctor lorem qui bibendum auctor aliquetenean proin gravida nibh Ipsum proin gravida.</p>
                            <p>Lorem Ipsum proin gravida nibh vel velit auctor aliquetenean sollicitudin, lorem qui bibendum auctor, nisi elit consequat gravida nibh vel velit auctor lorem qui bibendum auctor aliquetenean proin gravida nibh Ipsum proin gravida.</p>
                        </div>

                    </div>
                </div>

            </div>
<Footer/>


        </>
    );
};

export default WhatWeDo;